module.exports = __webpack_public_path__ + "static/media/50per.129e4a6e.mp4";